"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var use_toggle_state_hook_1 = __importDefault(require("../../hooks/use-toggle-state.hook"));

var editable_text_option_view_component_1 = require("../editable-text-option-view/editable-text-option-view.component");

var add_button_component_1 = __importDefault(require("../../common-components/add-button/add-button.component"));

var variable_text_editor_container_1 = __importDefault(require("../variable-text-editor/variable-text-editor.container"));

var add_text_option_button_styles_1 = require("./add-text-option-button.styles");

var AddTextOptionButton = function AddTextOptionButton(_ref) {
  var addTextOption = _ref.addTextOption;

  var _use_toggle_state_hoo = use_toggle_state_hook_1.default(),
      isEditorVisible = _use_toggle_state_hoo.state,
      close = _use_toggle_state_hoo.handleOff,
      open = _use_toggle_state_hoo.handleOn;

  return react_1.default.createElement(add_text_option_button_styles_1.WrapperDiv, null, react_1.default.createElement(add_button_component_1.default, {
    onClick: open
  }, "\u9078\u629E\u80A2\u8FFD\u52A0"), isEditorVisible && react_1.default.createElement(variable_text_editor_container_1.default, {
    rawText: '',
    onOverlayClick: close,
    onSave: function onSave(rawText) {
      addTextOption(rawText);
      close();
    },
    validate: editable_text_option_view_component_1.isValidLable
  }));
};

exports.default = AddTextOptionButton;